import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: "root",
})
export class EncriptionService {
  public isReloading: boolean = false;
  public viewDesencriptado: any = [];  
  
  // Clave secreta para el cifrado
  private secretKey = "claveAntiCambio";


  constructor(
  ) {
  }

  EncryptData(data: any): string {
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      this.secretKey
    ).toString();
    return encryptedData;
  }

  DecryptData(encryptedData: string): any {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
    const decryptedData = JSON.parse(
      decryptedBytes.toString(CryptoJS.enc.Utf8)
    );
    return decryptedData;
  }

  DecryptViews(){
    this.viewDesencriptado = this.DecryptData(localStorage.getItem("views"));
    this.viewDesencriptado = this.viewDesencriptado.sort( (a,b) => a.idOrder - b.idOrder);
    this.viewDesencriptado = this.viewDesencriptado.filter(view => view.name != "Configuración" && view.name != "Permisos Generales");
    // console.log("views",this.viewDesencriptado);
    return this.viewDesencriptado;
  }

  DecryptList(): any{
    var rolDesencriptado = null;
    if(localStorage.getItem("permissions") != null && localStorage.getItem("permissions") != "" && localStorage.getItem("permissions") != undefined){
      var permissionEncriptado = JSON.parse(localStorage.getItem("permissions"));
      rolDesencriptado = permissionEncriptado.map(permission => this.DecryptData(permission));
      // console.log("permisoooooos",rolDesencriptado);
    }
    return rolDesencriptado;
  }
}
